/* eslint-disable eqeqeq */
import BackendLayout from "../../layouts/BackendLayout";
import {useDispatch, useSelector} from "react-redux";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import {
  SEARCH_INSPECTION_HISTORY_CORRECTION,
  SEARCH_INSPECTION_HISTORY_CONFIRM,
  SEARCH_INSPECTION_HISTORY_RESULT,
} from "../../constants/routes";
import CustomSpan from "../../components/CustomSpan";
import React, {useEffect, useRef, useState} from "react";
import {useParams, useLocation} from "react-router-dom";
import {getSearchInspectionHistoryResultSettings} from "../../api/setting/pageApi";
import {setPageSettings} from "../../store/actions/pageActions";
import {getInformationInspection, update} from "../../services/search/InspectionHistoryCorrection";
import {errorStatusHandle, getFileIdsFromEditor, getSearchBackUrl} from "../../utils";
import {useDocumentTitle, useTableInspectionItemsScroll} from "../../hooks";
import {PageTitle} from "../../components/admin";
import Table from "../../components/table/Table";
import {
  Label,
  FormGroupInput,
  RemarkDetail,
  TextInput,
  DatetimePicker,
  ButtonBack,
  CheckboxInput,
  Button,
  TreatmentContent,
  JudgmentContent, InspectionInformationTable, JudgmentStatus, ButtonDPad, JudgmentLimit, RedirectAlert
} from "../../components";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import {
  resetAlert,
  setAlertSuccess,
  setRegisterInspectionAlertError,
  setButtonProcessing,
  clearButtonProcessing,
  clearPageLoading,
  setPageLoading
} from "../../store/actions";
import {useNavigate} from 'react-router-dom';
import PageAlert from '../../components/alerts/PageAlert';
import { formatDateTime} from "../../utils/datetime-utils";
import {hasErrorInput} from "../../utils";
import store from "../../store";
import Select2 from "../../components/Select2";
import {getSelectedValue} from "../../utils/select-utils";
import {HTTP_ERROR_CODES} from "../../constants/error";
import {LiaEditSolid} from "react-icons/lia";
import {smoothScrollToTop} from "../../utils/common-utils";
import {
  BUTTON_REGISTER_INSPECTION_CORRECTION,
} from "../../constants/buttons";
import ExpandablePanel from "../../components/ExpandablePanel";
import {
  getBackgroundSymbol,
  getInspectionJudgment,
  getInspectionUnit
} from "../../utils/display-utils";
import {INSPECTION_ITEM_JUDGMENT_INPUT_TYPE} from "../../constants/app";
import TextEditor from "../../components/form/inputs/TextEditor";
import TooltipComment from "../../components/TooltipComment"
import {SEARCH_INSPECTION_HISTORY_CORRECTION_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";


export default function InspectionHistoryCorrectionPage() {
  useRedirectPage(SEARCH_INSPECTION_HISTORY_CORRECTION_PAGE);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const {workflowId, inspectionId} = useParams();
  const location = useLocation();
  const searchParams = location.state || {};
  const [inspection, setInspection] = useState({});
  const [group, setGroup] = useState({});
  const [judgmentStatus, setJudgmentStatus] = useState(null);
  const [commentFiles, setCommentFiles] = useState([]);
  const [commentImagesThumb, setCommentImagesThumb] = useState([]);
  const [judgments, setJudgments] = useState([]);
  const [inspectionItem, setInspectionItem] = useState([]);
  const [inspectionResult, setInspectionResult] = useState([]);
  const auth = store.getState().auth;
  const [formRegister, setFormRegister] = useState({
    'correction_user_id': auth.user.id
  });
  const [treatment, setTreatment] = useState({});
  const [errorMessagesRegister, setErrorMessagesRegister] = useState([]);
  const resultField = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_field
  );
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const maxHeightTable = useTableInspectionItemsScroll(tableRef, inspectionItem);


  const formatDisplayUser = (user) => {
    return `${user.name} (${user.username})`
  };
  const correctionUserOptions = [{value: auth.user.id, label: formatDisplayUser(auth.user)}];

  useEffect(() => {
    const successMessage = localStorage.getItem('successMessage');
    if (successMessage) {
      dispatch(setAlertSuccess(successMessage));
      localStorage.removeItem('successMessage')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setInspectionHistoryCorrectionPageSettings(workflowId, inspectionId, searchParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflowId, inspectionId]);

  const handleInputChange = (key, value) => {
    setFormRegister(prev => ({
      ...prev,
      [key]: value
    }))
  };

  const setInspectionHistoryCorrectionPageSettings = async (workflowId, inspectionId) => {
    dispatch(setPageLoading());
    try {
      const pageSettings = await getSearchInspectionHistoryResultSettings();
      dispatch(setPageSettings(pageSettings));

      const informationInspection = await getInformationInspection(workflowId, inspectionId);
      const inspection = informationInspection.data.inspection;
      setInspection(inspection);
      formRegister['correction_registration_datetime'] = pageSettings.datetime;
      formRegister['has_inspected'] = inspection['result'] !== -1;
      setJudgmentStatus(informationInspection.data.judgment_status);
      setJudgments(informationInspection.data.judgments);
      setTreatment(inspection.inspection_treatment);


      const listInspectionResult = informationInspection.data.inspection.result_inspection;
      setGroup(informationInspection.data.inspection.machine.group_relation);
      setInspectionItem(informationInspection.data.inspection.inspection_item);
      setInspectionResult(listInspectionResult);

      const updatedFormRegister = Object.keys(resultField).reduce((acc, key) => {
        if (key.toLowerCase().includes("datetime")) {
          acc[key] = inspection[key] ? formatDateTime(new Date(inspection[key])) : '-';
        }
        if (key === 'inspection_start_user_id') {
          acc[key] = formatDisplayUser(inspection['inspection_start_user'])
        }
        if (key === 'operation_start_user_id') {
          acc[key] = inspection['operation_start_user'] ? formatDisplayUser(inspection['operation_start_user']) : '-'
        }
        return acc
      }, {...formRegister});

      const updatedForm = listInspectionResult.reduce((acc, item, index) => {
        acc[`inspection_item_${item.inspection_item_id}`] = item.inspection_item_value;
        return acc;
      }, {...updatedFormRegister});
      setFormRegister(updatedForm);
    } catch (e) {
      errorStatusHandle(e);
    } finally {
      dispatch(clearPageLoading());
    }
  };

  const firstInputIndex = inspectionItem.findIndex(item => item.inspection_item_type.name === 'input');

  const handleSelectChange = (selectOption, name) => {
    var value = '';
    if (selectOption) {
      value = selectOption.value
    }

    setFormRegister({
      ...formRegister,
      [name]: value
    })
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(setButtonProcessing(BUTTON_REGISTER_INSPECTION_CORRECTION));
    try {
      const formData = new FormData();
      Object.keys(formRegister).forEach(key => {
        if (formRegister[key] !== null) {
          formData.append(key, formRegister[key])
        } else {
          formData.append(key, '')
        }
      });

      if (formRegister?.remark_text) {
        const fileIdsInEditor = getFileIdsFromEditor(formRegister.remark_text);
        const filteredFiles = commentFiles.filter(file => fileIdsInEditor.includes(file.id));
        const filteredImagesThumb =  commentImagesThumb.filter(file => fileIdsInEditor.includes(file.id));

        filteredFiles.forEach((file) => {
          formData.append('comment_file_ids', file.id);
          formData.append('comment_files', file.file);
        });

        filteredImagesThumb.forEach((file) => {
          formData.append('comment_images_thumb', file.file);
          formData.append('comment_image_thumb_ids', file.id);
        });

        fileIdsInEditor.forEach((id) => {
          formData.append('all_comment_file_ids', id);
        });
      }

      const response = await update(workflowId, inspectionId, formData);
      setErrorMessagesRegister([]);
      localStorage.setItem('successMessage', response.message);
      window.location.reload();
      smoothScrollToTop();
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
        let responseData = e.data;
        dispatch(setRegisterInspectionAlertError(responseData));
        setErrorMessagesRegister(responseData.errors)
      }
      smoothScrollToTop();
    } finally {
      dispatch(clearButtonProcessing(BUTTON_REGISTER_INSPECTION_CORRECTION));
    }
  };

  const handleCheckBoxChange = (key, value) => {
    setFormRegister(prev => {
      const newFormRegister = {...prev};
      if (newFormRegister[key] === value) {
        newFormRegister[key] = '';
      } else {
        newFormRegister[key] = value;
      }
      return newFormRegister;
    });
  };

  const handleButtonBack = () => {
    dispatch(resetAlert());
    if (Object.keys(searchParams).length === 0) {
      navigate(SEARCH_INSPECTION_HISTORY_CONFIRM.replace(':workflowId', workflowId).replace(':inspectionId', inspectionId));
    } else {
      navigate(SEARCH_INSPECTION_HISTORY_CONFIRM.replace(':workflowId', workflowId).replace(':inspectionId', inspectionId), {state: searchParams});
    }
  };

  const handleCheckInspected = () => {
    setFormRegister(prev => {
      const newFormRegister = {...prev};
      inspectionItem.forEach(item => {
        const key = `inspection_item_${item.id}`;
        if (key in newFormRegister) {
          newFormRegister[key] = '';
        }
      });
      newFormRegister.has_inspected = !prev.has_inspected;
      return newFormRegister
    });
    setErrorMessagesRegister([]);
    dispatch(resetAlert());
  };

  const handleNavigateBreadcrumb = () => {
    const params = location.state?.searchParams || {};
    navigate(getSearchBackUrl(params, '', SEARCH_INSPECTION_HISTORY_RESULT), {state: params})
  };

  const breadcrumb = getPageBreadcrumb(SEARCH_INSPECTION_HISTORY_CORRECTION, handleNavigateBreadcrumb);
  useDocumentTitle("点検履歴(修正) - 点検王");
  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <ButtonDPad />
      <div
        className="w-full flex flex-col justify-start xl:gap-[24px] gap-[18px] flex-1"
        id="top_scroll">
        <PageTitle title="点検履歴(修正)" className="!mb-0"/>
        <RedirectAlert className="!mb-0" />
        <PageAlert className="!mb-0"/>
        <div className="flex flex-col w-full max-w-[1674px] min-w-[1120px]">
          <div className='flex flex-col xl:gap-[32px] gap-[28px] lg:pr-0 pr-6'>
            <div className="flex items-center gap-[20px] items-stretch">
              <InspectionInformationTable inspection={inspection} group={group}/>
              <JudgmentStatus judgmentStatus={judgmentStatus} workflowId={workflowId} inspectionId={inspectionId}/>
            </div>
            <div className="flex flex-col gap-[8px]">
              <div className="flex justify-end items-center">
                <CheckboxInput name="has_inspected" id="has_inspected"
                               checked={!formRegister['has_inspected']}
                               onChange={handleCheckInspected}
                               label="設備が停止中のため点検しない" >
                </CheckboxInput>
              </div>
              <ExpandablePanel title="点検結果">
                <div className="w-full relative rounded-lg border border-[#e0e0e0] overflow-y-auto" style={{
                  maxHeight: maxHeightTable ? `${maxHeightTable}px` : "auto"
                }} ref={tableRef}>
                  <Table className="no-drop-shadow-table" striped>
                    <Table.Head className={`border-b border-tenken-gray-200 ${maxHeightTable ? 'sticky top-0 z-[8]' : ''}`}>
                      <Table.HeadCell className="!normal-case w-[76px] scrollable-table-header-bg">
                        <span>No.</span>
                      </Table.HeadCell>
                      <Table.HeadCell className="max-w-[938px] scrollable-table-header-bg">
                        <span className="whitespace-nowrap">点検項目</span>
                      </Table.HeadCell>
                      <Table.HeadCell className="scrollable-table-header-bg">
                        <span className="whitespace-nowrap">判定基準</span>
                      </Table.HeadCell>
                      <Table.HeadCell className="scrollable-table-header-bg">
                        <span className="whitespace-nowrap">下限</span>
                      </Table.HeadCell>
                      <Table.HeadCell className="scrollable-table-header-bg">
                        <span className="whitespace-nowrap">上限</span>
                      </Table.HeadCell>
                      <Table.HeadCell className="scrollable-table-header-bg"></Table.HeadCell>
                      <Table.HeadCell className="scrollable-table-header-bg">
                        <span className="whitespace-nowrap">留意事項</span>
                      </Table.HeadCell>
                      <Table.HeadCell className="scrollable-table-header-bg 2xl:w-[320px] xl:w-[240px] w-[200px]">
                        <span className="whitespace-nowrap">点検結果</span>
                      </Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="devide-y text-base break-all">
                      {inspectionItem && inspectionItem.length > 0 ? (
                        inspectionItem.map((item, index) => (
                          <Table.Row key={index}
                                     className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200">
                            <Table.Cell>
                              <span>{item.item_order}</span>
                            </Table.Cell>
                            <Table.Cell className="max-w-[400px]">
                              <span
                                style={{color: item.title_color}}
                                className="break-all"
                              >
                                {item.title}
                              </span>
                            </Table.Cell>
                            <Table.Cell className="max-w-[300px]">
                              <span
                                style={{color: item.description_color}}
                                className="break-all"
                              >
                                {item.description}
                              </span>
                            </Table.Cell>
                            <Table.Cell className="max-w-[300px]">
                              <JudgmentLimit
                                value={item.inspection_judgment?.lower_value}
                                boundaryType={item.inspection_judgment?.lower_boundary_type}
                                unit={item.unit}
                                type="lower"
                              />
                            </Table.Cell>
                            <Table.Cell className="max-w-[300px]">
                              <JudgmentLimit
                                value={item.inspection_judgment?.upper_value}
                                boundaryType={item.inspection_judgment?.upper_boundary_type}
                                unit={item.unit}
                                type="upper"
                              />
                            </Table.Cell>
                            <Table.Cell className="px-2">
                              <CustomSpan
                                className="whitespace-nowrap"
                                title={item.unit}
                              >
                                {item.unit ? getInspectionUnit(item.unit, true) : '-'}
                              </CustomSpan>
                            </Table.Cell>
                            <Table.Cell>
                              <RemarkDetail key={index} rowData={item}/>
                            </Table.Cell>
                            <Table.Cell>
                              {(() => {
                                const foundResult = inspectionResult.find(
                                  (isResult) => isResult.inspection_item_id === item.id
                                );
                                return foundResult ? (
                                  <>
                                    {item.inspection_item_type?.name == 'input' && (
                                      <FormGroupInput className="items-center relative w-full">
                                        {getInspectionUnit(item.unit) !== "" ? (
                                          <>
                                            <TextInput
                                              name={`inspection_item_${item.id}`} type="text"
                                              onChange={(e) => handleInputChange(`inspection_item_${item.id}`, e.target.value)}
                                              value={formRegister[`inspection_item_${item.id}`] || ''}
                                              readOnly={!formRegister['has_inspected']}
                                              disabled={!formRegister['has_inspected']}
                                              autoFocus={index === firstInputIndex}
                                              hasError={hasErrorInput(errorMessagesRegister, `inspection_item_${item.id}`)}
                                              {...(item.inspection_judgment?.input_value_type === INSPECTION_ITEM_JUDGMENT_INPUT_TYPE.TEXT)
                                                ? {maxLength: item.inspection_judgment?.max_string_length}
                                                : {}
                                              }
                                              className="w-full tenken__text-gray-900 min-w-[200px] max-w-[280px] focus:ring-0 focus:border-[#D0D5DD] bg-white 2xl:pl-[14px] 2xl:pr-[104px] 2xl:py-[10px] xl:pl-[12px] xl:pr-[96px] xl:py-[8px] md:pl-[10px] md:pr-[40px] md:py-[6px] rounded-lg border border-[#D0D5DD]"/>
                                            <CustomSpan
                                              title={item.unit}
                                              className="absolute right-3 2xl:text-[16px] tenken__text-gray-900 xl:text-[15px] md:text-[14px]"
                                            >
                                              {getInspectionUnit(item.unit)}
                                            </CustomSpan>
                                          </>
                                        ) : (
                                          <>
                                            <TextInput
                                              name={`inspection_item_${item.id}`} type="text"
                                              onChange={(e) => handleInputChange(`inspection_item_${item.id}`, e.target.value)}
                                              value={formRegister[`inspection_item_${item.id}`] || ''}
                                              readOnly={!formRegister['has_inspected']}
                                              disabled={!formRegister['has_inspected']}
                                              autoFocus={index === firstInputIndex}
                                              hasError={hasErrorInput(errorMessagesRegister, `inspection_item_${item.id}`)}
                                              {...(item.inspection_judgment?.input_value_type === INSPECTION_ITEM_JUDGMENT_INPUT_TYPE.TEXT)
                                                ? {maxLength: item.inspection_judgment?.max_string_length}
                                                : {}
                                              }
                                              className="w-full tenken__text-gray-900 min-w-[200px] max-w-[280px] focus:ring-0 focus:border-[#D0D5DD] bg-white 2xl:px-[14px] 2xl:py-[10px] xl:px-[12px] xl:py-[8px] md:px-[10px] md:py-[6px] rounded-lg border border-[#D0D5DD]"/>
                                          </>
                                        )}
                                      </FormGroupInput>
                                    )}
                                    {item.inspection_item_type?.name == 'checkbox' && (
                                      <div className="flex items-center 2xl:gap-[32px] xl:gap-[28px] gap-[24px]">
                                        <CheckboxInput name={`inspection_item_${item.id}`}
                                                       id={`inspection_item_OK_${item.id}`}
                                                       value="OK"
                                                       disabled={!formRegister['has_inspected']}
                                                       onChange={() => handleCheckBoxChange(`inspection_item_${item.id}`, 'OK')}
                                                       checked={formRegister[`inspection_item_${item.id}`] === 'OK'}
                                                       label={resultSymbolSetting['passed'].symbol}
                                                       labelStyle={{
                                                         color: resultSymbolSetting.passed.color,
                                                         background: getBackgroundSymbol(resultSymbolSetting, 'passed')
                                                       }}
                                                       classLabel="xl:text-[20px] text-[18px]">
                                        </CheckboxInput>
                                        <CheckboxInput name={`inspection_item_${item.id}`}
                                                       id={`inspection_item_NG_${item.id}`}
                                                       value="NG"
                                                       disabled={!formRegister['has_inspected']}
                                                       onChange={() => handleCheckBoxChange(`inspection_item_${item.id}`, 'NG')}
                                                       checked={formRegister[`inspection_item_${item.id}`] === 'NG'}
                                                       label={resultSymbolSetting['failed'].symbol}
                                                       labelStyle={{
                                                         color: resultSymbolSetting.failed.color,
                                                         background: getBackgroundSymbol(resultSymbolSetting, 'failed')
                                                       }}
                                                       classLabel="xl:text-[20px] text-[18px]">
                                        </CheckboxInput>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  null
                                )
                              })()}
                            </Table.Cell>
                          </Table.Row>
                        ))) : (
                        null
                      )}
                    </Table.Body>
                  </Table>
                </div>
                <div className="relative rounded-lg border border-[#e0e0e0] w-full">
                  <Table className="no-drop-shadow-table" striped>
                    <Table.Head className="whitespace-nowrap border-b border-tenken-gray-200">
                      <Table.HeadCell
                        className="w-[40%] !bg-white"
                      >
                        <span>点検者情報</span>
                      </Table.HeadCell>
                      <Table.HeadCell className="!bg-white">
                      </Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="devide-y text-base whitespace-nowrap">
                      {resultField && Object.keys(resultField).length > 0 ? (
                        Object.entries(resultField).map(([key, title], index) => (
                          key != 'registration_datetime' && (
                            <Table.Row key={index}
                                       className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200">
                              <Table.Cell>
                                <span className="tenken__text-gray-900">{title}</span>
                              </Table.Cell>
                              <Table.Cell>
                                <FormGroupInput className="!flex-col">
                                  <FormGroupInput className="gap-[20px]">
                                    <CustomSpan text={formRegister[key]} />
                                  </FormGroupInput>
                                </FormGroupInput>
                              </Table.Cell>
                            </Table.Row>
                          )
                        ))
                      ) : (
                        null
                      )}
                      <Table.Row
                        className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200">
                        <Table.Cell>
                          <span className="tenken__text-gray-900">修正作業日時</span>
                        </Table.Cell>
                        <Table.Cell>
                          <FormGroupInput className="!flex-col">
                            <FormGroupInput className="gap-[20px]">
                              <DatetimePicker name="correction_registration_datetime"
                                              id='correction_registration_datetime'
                                              onChange={handleInputChange}
                                              maxLength={16}
                                              value={formRegister['correction_registration_datetime']}
                                              hasError={hasErrorInput(errorMessagesRegister, 'correction_registration_datetime')}
                                              className="tenken__text-gray-900 2xl:w-[320px] xl:w-[300px] lg:w-[280px] md:w-[260px] 2xl:px-[14px] 2xl:py-[10px] xl:px-[12px] xl:py-[8px] md:px-[10px] md:py-[6px] rounded-lg border border-[#D0D5DD] focus:ring-0 focus:border-[#D0D5DD]">
                              </DatetimePicker>

                            </FormGroupInput>
                          </FormGroupInput>
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row
                        className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200">
                        <Table.Cell>
                          <span className="tenken__text-gray-900">修正作業者</span>
                        </Table.Cell>
                        <Table.Cell>
                          <FormGroupInput className="!flex-col">
                            <FormGroupInput className="gap-[20px]">
                              <Select2
                                options={correctionUserOptions}
                                className="xl:text-base text-gray-900 2xl:w-[320px] xl:w-[300px] lg:w-[280px] md:w-[260px] tenken__text-gray-900"
                                classNamePrefix="react-select"
                                maxLength={20}
                                onChange={(correctionUserOptions) => handleSelectChange(correctionUserOptions, 'correction_user_id')}
                                value={getSelectedValue(correctionUserOptions, formRegister['correction_user_id'])}
                                placeholder=''
                                name="correction_user_id"
                                hasError={hasErrorInput(correctionUserOptions, 'correction_user_id')}
                              />
                            </FormGroupInput>
                          </FormGroupInput>
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </div>
                <div className="flex flex-col bg-[#FFF] items-start self-stretch w-full xl:gap-[16px] gap-[12px]">
                  <div className="flex items-center">
                    <Label className="font-medium" text="点検コメント"/>
                    <TooltipComment/>
                  </div>
                  <TextEditor
                    onChange={handleInputChange}
                    name="remark_text"
                    remarkText={inspection?.remark_text}
                    commentFiles={inspection?.inspection_comment_files}
                    setCommentFiles={setCommentFiles}
                    setCommentImagesThumb={setCommentImagesThumb}
                  />
                </div>
              </ExpandablePanel>
            </div>
            <TreatmentContent treatments={treatment} inspectionItem={inspectionItem} inspection={inspection}/>
            <JudgmentContent judgments={judgments}/>
            <div className="flex items-center py-[10px] 2xl:gap-[120px] xl:gap-[100px] gap-[80px] justify-center"
                 id="end_scroll">
              <ButtonBack onClick={() => handleButtonBack()}/>
              <Button type="submit" theme={tenkenTheme.button} color="primary" onClick={(e) => handleSubmit(e)}
                      id={BUTTON_REGISTER_INSPECTION_CORRECTION}
                      className="rounded-lg border min-w-[280px]">
                <LiaEditSolid className="text-white font-medium mr-[2px]" size={20}/>
                登録
              </Button>
            </div>
          </div>
        </div>
      </div>
    </BackendLayout>
  );
}
